import en from './en/';
import en_au from './en-au';
import en_us from './en-us';

export default {
	'en': en,
	'en-au': en_au,
	'en-us': en_us,
};



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/lib/i18n/lang/index.js